/**
 * @generated SignedSource<<e856ad9107eaca5f7caa0a3ba51e7dc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_MaybeRowWithDragAndDrop_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_project" | "row_nativeIssueTable_RowWithDragAndDrop_project">;
  readonly " $fragmentType": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project";
};
export type row_nativeIssueTable_MaybeRowWithDragAndDrop_project$key = {
  readonly " $data"?: row_nativeIssueTable_MaybeRowWithDragAndDrop_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_MaybeRowWithDragAndDrop_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowWithDragAndDrop_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowInner_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "22d1625372ec1bb4cc986747310780cc";

export default node;
